/**
 * @generated SignedSource<<2183f067e12a93e68f7b54ab19054bab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NumberOfEmployeesRange = "C_00001_00010" | "C_00011_00050" | "C_00051_00100" | "C_00101_00250" | "C_00251_00500" | "C_00501_01000" | "C_01001_05000" | "C_05001_10000" | "C_10001_MAX" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CompanyProfileLayoutV2_organization$data = {
  readonly description: string | null;
  readonly externalLinks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly label: string | null;
        readonly url: string;
      };
    }>;
  };
  readonly id: string;
  readonly industryCategories: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
  readonly isClaimed: boolean;
  readonly isVerified: boolean;
  readonly jobs: {
    readonly count: number;
  };
  readonly location: string | null;
  readonly logoImage: {
    readonly dominantHexColor: string | null;
  } | null;
  readonly name: string;
  readonly numberOfEmployees: NumberOfEmployeesRange | null;
  readonly slug: string | null;
  readonly url: string | null;
  readonly userReviews: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly author: {
          readonly avatarImage: {
            readonly id: string;
            readonly uid: string;
            readonly url: string;
          } | null;
          readonly firstName: string | null;
          readonly id: string;
        };
      };
    }>;
  };
  readonly visitorCanEdit: boolean;
  readonly visitorIsMember: boolean;
  readonly workspace: {
    readonly activeSubscription?: {
      readonly createdAt: ContraAPIScalars.DateTime | null;
    } | null;
  } | null;
  readonly yearFounded: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"CompanyProfileMainContentV2_organization" | "CompanyProfileMenuV2_organization" | "EditableCompanyLogoV2_organization" | "EssentialInfoV2_organization" | "InlineDescriptionV2_organization" | "WelcomeToYourCompanyProfileModal_organization">;
  readonly " $fragmentType": "CompanyProfileLayoutV2_organization";
};
export type CompanyProfileLayoutV2_organization$key = {
  readonly " $data"?: CompanyProfileLayoutV2_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompanyProfileLayoutV2_organization">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompanyProfileLayoutV2_organization",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isClaimed",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerified",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrganizationExternalLinkConnection",
      "kind": "LinkedField",
      "name": "externalLinks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationExternalLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrganizationExternalLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "label",
                  "storageKey": null
                },
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfEmployees",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorIsMember",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IndustryCategoryConnection",
      "kind": "LinkedField",
      "name": "industryCategories",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IndustryCategoryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IndustryCategory",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "statuses": [
              "POSTED"
            ]
          }
        }
      ],
      "concreteType": "OrganizationJobConnection",
      "kind": "LinkedField",
      "name": "jobs",
      "plural": false,
      "selections": [
        (v3/*: any*/)
      ],
      "storageKey": "jobs(filter:{\"statuses\":[\"POSTED\"]})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserReviewConnection",
      "kind": "LinkedField",
      "name": "userReviews",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "UserReviewEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserReview",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserProfile",
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ContraImage",
                      "kind": "LinkedField",
                      "name": "avatarImage",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/),
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "uid",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "yearFounded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContraImage",
      "kind": "LinkedField",
      "name": "logoImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dominantHexColor",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "workspace",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ClientWorkspaceSubscription",
              "kind": "LinkedField",
              "name": "activeSubscription",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ClientWorkspace",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CompanyProfileMenuV2_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CompanyProfileMainContentV2_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditableCompanyLogoV2_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EssentialInfoV2_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InlineDescriptionV2_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WelcomeToYourCompanyProfileModal_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "66037d6b56fdee2773c5f9252112d2b2";

export default node;
